import React, { useState, useRef } from 'react'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './Home.css'
import html2canvas from "html2canvas";

const Home = () => {
    const exportRef = useRef();
    const [inputs, setInputs] = useState({})
    const [checkinputs, setCheckInputs] = useState({})

    const [selectSocial, setSelectSocial] = useState({
        linkedin: "images/linkedin.png",
        instagram: "images/instagram.png",
        twitter: "images/twitter.png",
        facebook: "images/facebook.png",
    })

    const [bgimage, setbgImage] = useState();
    const [profileimage, setProfileImage] = useState();


    const changedInput = (event) => {
        let itemName = event.target.id;
        let itemValue = event.target.value;
        setInputs((preValue) => {
            return {
                ...preValue, [itemName]: itemValue,
            }
        })
    }

    const changedSelects = (event) => {
        let itemName = event.target.id;
        let itemValue = event.target.checked;
        setCheckInputs((preValue) => {
            return {
                ...preValue, [itemName]: itemValue,
            }
        })
    }


    const changedBgImage = (event) => {
        event.preventDefault();
        let itemValue = URL.createObjectURL(event.target.files[0]);
        setbgImage(itemValue)
    }

    const changeProfileImg = (event) => {
        event.preventDefault();
        let itemValue = URL.createObjectURL(event.target.files[0]);
        setProfileImage(itemValue)
    }

    const exportAsImage = async (element, imageFileName) => {
        const canvas = await html2canvas(element);
        const image = canvas.toDataURL("image/png", 1.0);
        downloadImage(image, imageFileName);
    };

    const downloadImage = (blob, fileName) => {
        const fakeLink = window.document.createElement("a");
        fakeLink.style = "display:none;";
        fakeLink.download = fileName;
        fakeLink.href = blob;
        document.body.appendChild(fakeLink);
        fakeLink.click();
        document.body.removeChild(fakeLink);

        fakeLink.remove();
    };


    return (
        <div className='main-container'>
            <div className='container d-flex justify-content-end pt-5 px-4'>
                <div id="download" onClick={() => exportAsImage(exportRef.current, "post")}>Download<span className='mx-2'><svg width="15px" height="15px" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" /></svg></span></div>
            </div>
            <div className='py-5 container'>
                <div className={`w-100 d-flex justify-content-between linked-post`}>
                    <div className='px-3 py-4 rounded'>
                        <h4>Create Post</h4>
                        <form>
                            <div className="form-group mb-3">
                                <input type={"text"} className="form-control" id="name" value={inputs.name} aria-describedby="emailHelp" placeholder="(e.g John Doe)" onChange={changedInput}></input>
                            </div>
                            <div className="form-group mb-3">
                                <input type={"text"} className="form-control" id="username" value={inputs.username} placeholder="(e.g john)" onChange={changedInput}></input>
                            </div>
                            <div className="form-group mb-3">
                                <textarea className="form-control" id="content" rows="3" placeholder='content' value={inputs.content} onChange={changedInput}></textarea>
                            </div>
                            <div className="form-group mb-3">
                                <label className='mx-2'>Profile Image:</label>
                                <input type="file" className="form-control-file small-inputs" id="profile_image" onChange={changeProfileImg} accept="image/*"></input>
                            </div>
                            <div className='my-5'>
                                <h4 className='mx-2'>Text Color</h4>
                                <div className='form-group mb-3 mx-2 my-3 d-flex'>
                                    <div>
                                        <label for="textColor" className="form-label">Content</label>
                                        <input type="color" class="form-control form-control-color" id="textColor" value={inputs.textColor} title="Choose your color" onChange={changedInput}></input>
                                    </div>
                                    <div className='mx-5'>
                                        <label for="nameColor" className="form-label">Name</label>
                                        <input type="color" class="form-control form-control-color" id="nameColor" value={inputs.nameColor} title="Choose your color" onChange={changedInput}></input>
                                    </div>
                                    <div>
                                        <label for="innerBg" className="form-label">Inner-Bg</label>
                                        <input type="color" class="form-control form-control-color" id="innerBg" value={inputs.innerBg} title="Choose your color" onChange={changedInput}></input>
                                    </div>

                                </div>
                            </div>


                            <div className='my-5'>
                                <h4 className='mx-2'>Background Type</h4>
                                <div className="form-group mb-3 mx-2 my-1 d-flex">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value={checkinputs.bgColorCheck} name='bgColorCheck' id="bgColorCheck" onChange={changedSelects} disabled={checkinputs.bgImageCheck ? "disabled" : ""}></input>
                                        <label class="form-check-label" for="bgColorCheck">
                                            Background Color
                                        </label>
                                    </div>
                                    <div class="form-check mx-4">
                                        <input className="form-check-input" type="checkbox" value={checkinputs.bgImageCheck} name="bgImageCheck" id="bgImageCheck" onChange={changedSelects} disabled={checkinputs.bgColorCheck ? "disabled" : ""}></input>
                                        <label className="form-check-label" for="bgImageCheck">
                                            Background Image
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {checkinputs.bgImageCheck && !checkinputs.bgColorCheck ? <div className="form-group mb-3">
                                <label className='mx-2'>Background Image:</label>
                                <input type="file" className="form-control-file small-inputs" id="bgimage" onChange={changedBgImage} accept="image/*"></input>
                            </div> : ""}


                            {checkinputs.bgColorCheck && !checkinputs.bgImageCheck ? <div className='form-group mb-3 my-4 mx-2'>
                                <label for="exampleColorInput" className="form-label">Background Color</label>
                                <input type="color" class="form-control form-control-color" id="bgColor" value={inputs.bgColor ? inputs.bgColor : "#ff0088"} title="Choose your color" onChange={changedInput}></input>
                            </div> : ""}

                            <div className='my-5'>
                                <h4 className='mx-2'>Social</h4>

                                <select class="form-select" aria-label="Default select example" id="selectSocial" onChange={changedInput}>
                                    <option selected>Default</option>
                                    <option value="linkedin">LinkedIn</option>
                                    <option value="instagram">Instagram</option>
                                    <option value="twitter">Twitter</option>
                                    <option value="facebook">Facebook</option>
                                </select>
                            </div>
                        </form>


                    </div>
                    <div>
                        {!checkinputs.bgColorCheck ? <div className='post' ref={exportRef} >
                            <img src={(bgimage) ? `${bgimage}` : `images/bluebg.jpg`}></img>
                            <div className='post_content'>
                                <div className='post-inner' style={{ backgroundColor: inputs.innerBg }}>
                                    <div className='d-flex align-item-center'>
                                        <img src={(profileimage) ? `${profileimage}` : `images/profile.png`} className='profile'></img>
                                        <div className='name-div d-flex justify-content-center flex-column'>
                                            <span className='name' style={{ color: inputs.nameColor }}>{(inputs.name) ? inputs.name : 'Your Name'}</span>
                                            <span className='username' style={{ color: inputs.nameColor }}>@{(inputs.username) ? (inputs.username) : 'Your Username'}</span>
                                        </div>
                                        <span className='img-span mx-3'><img src={inputs.selectSocial ? selectSocial[inputs.selectSocial] : selectSocial['linkedin']}></img></span>
                                    </div>
                                    <div className='para-text text-4 my-4'>
                                        {inputs.content ? <em style={{ color: inputs.textColor }}><blockquote>{inputs.content}</blockquote></em> : <em style={{ color: inputs.textColor }}><blockquote>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde esse amet modi voluptas quaerat fuga sint necessitatibus!
                                        </blockquote></em>}
                                        {inputs.username ? <p className='text-center mt-4' style={{ fontSize: "14px", color: inputs.nameColor }}>@{inputs.username}</p> : <p className='text-center mt-4' style={{ fontSize: "14px", color: inputs.nameColor }}>@ username</p>}

                                    </div>


                                </div>
                            </div>
                        </div> : ""}

                        {checkinputs.bgColorCheck && !checkinputs.bgImageCheck ? <div className='post-second' ref={exportRef} >
                            <div className='post_content' style={{ backgroundColor: inputs.bgColor }}>
                                <div className='post-inner' style={{ backgroundColor: inputs.innerBg }}>
                                    <div className='d-flex align-item-center'>
                                        <img src={(profileimage) ? `${profileimage}` : `images/profile.png`} className='profile'></img>
                                        <div className='name-div d-flex justify-content-center flex-column'>
                                            <span className='name' style={{ color: inputs.nameColor }}>{(inputs.name) ? inputs.name : 'Your Name'}</span>
                                            <span className='username' style={{ color: inputs.nameColor }}>@{(inputs.username) ? (inputs.username) : 'Your Username'}</span>
                                        </div>
                                        <span className='img-span mx-3'><img src={selectSocial[inputs.selectSocial]}></img></span>
                                    </div>
                                    <div className='para-text text-4 my-4'>
                                        {inputs.content ? <em style={{ color: inputs.textColor }}><blockquote>{inputs.content}</blockquote></em> : <em style={{ color: inputs.textColor }}><blockquote>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde esse amet modi voluptas quaerat fuga sint necessitatibus!
                                        </blockquote></em>}
                                        {inputs.username ? <p className='text-center mt-4' style={{ fontSize: "14px", color: inputs.nameColor }}>@{inputs.username}</p> : <p className='text-center mt-4' style={{ fontSize: "14px", color: inputs.nameColor }}>@ username</p>}

                                    </div>


                                </div>
                            </div>
                        </div> : ""}

                    </div>

                </div>
            </div>

        </div >
    )

}


export default Home